import { HsabAccountNametag } from "@/shared/types";
import moment from "moment/moment";


export function getNotionalAccountDisplay (notionalAccount: HsabAccountNametag, includeParens = true): string {
    if (!notionalAccount) {
        return "";
    }

    if (notionalAccount.startDate === null || notionalAccount.endDate === null) {
        return notionalAccount.accountName;
    }
    const startYear = moment(notionalAccount.startDate).year();
    let endYear = moment(notionalAccount.endDate).year();
    if (startYear === endYear) {
        if (includeParens) {
            return `${notionalAccount.accountName} (${startYear})`;
        } else {
            return `${notionalAccount.accountName} ${startYear}`;
        }
    }
    endYear = moment(notionalAccount.endDate, "YYY").year();
    if (includeParens) {
        return `${notionalAccount.accountName} (${startYear}-${endYear})`;
    } else {
        return `${notionalAccount.accountName} ${startYear}-${endYear}`;
    }
}